import { createContext } from 'react';
export const HighlySensitivePropertyContext = /*#__PURE__*/createContext(undefined);